export const markAsRead = "rRa";
export default {markAsRead};